export default () => ({
  workOrder: null,
  technicians: []
})



// WEBPACK FOOTER //
// ./src/store/modules/maintenance/state.js